import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import { fetchConversionFunnel } from "../../../api/nystats";
import { setLoading } from "../../user-container/reducer/userSlice";

export default function ConversionFunnelTable() {
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  const [funnelData, setFunnelData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true)
        const data = await fetchConversionFunnel(filter);
        setFunnelData(data || []);
      } catch (e) {
        console.error("Error loading conversion funnel", e);
        setFunnelData([]);
      }
      setIsLoading(false)
    };
    load();
  }, [JSON.stringify(filterWithoutUTM)]);

  return (
    <Box
      sx={{
        border: "1px solid #E8E8E8",
        p: 2,
        borderRadius: "12px",
        background: "#fff",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: 600,
          color: "#101828",
          mb: 3,
          borderLeft: "3px solid #FBBF24",
          pl: 1,
        }}
      >
        Funnel Breakdown
      </Typography>
      {isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography></Box> :
        <TableContainer sx={{ maxHeight: 550 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, background: "#fff" }}>
                  Step Name
                </TableCell>
                <TableCell sx={{ fontWeight: 600, background: "#fff" }}>
                  Started
                </TableCell>
                <TableCell sx={{ fontWeight: 600, background: "#fff" }}>
                  Completed
                </TableCell>
                <TableCell sx={{ fontWeight: 600, background: "#fff" }}>
                  Drop-off %
                </TableCell>
                {/* <TableCell sx={{ fontWeight: 600, background: "#fff" }}>
                Avg Time
              </TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {funnelData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontSize: "14px" }}>
                    <Typography
                      variant="span"
                      sx={{
                        background: "#F7F2E8",
                        color: "#CC9933",
                        minWidth: "28px",
                        height: "28px",
                        fontSize: "14px",
                        borderRadius: "8px",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      {index + 1}
                    </Typography>{" "}
                    {row.step}
                  </TableCell>
                  <TableCell sx={{ fontSize: "14px" }}>
                    {(row.started ?? 0).toLocaleString()}
                  </TableCell>
                  <TableCell sx={{ fontSize: "14px" }}>
                    {(row.completed ?? 0).toLocaleString()}
                  </TableCell>
                  <TableCell sx={{ color: "#FD245C", fontWeight: 600 }}>
                    {row.drop}
                  </TableCell>
                  {/* <TableCell>{row.time}</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    </Box>
  );
}